import { cn } from "@/utils/theme";
import { Badge, Icon, Input } from "@elaniintc/goes-design-system";
import type { ComponentProps } from "react";

const SearchInput = ({
  className,
  showCount = false,
  count = 0,
  disabled,
  ...props
}: ComponentProps<typeof Input> & { showCount?: boolean; count?: number }) => {
  return (
    <div className="relative">
      {showCount && (
        <Badge
          shape="pill"
          className="absolute left-2 top-1/2 transform -translate-y-1/2 text-body text-sm leading-2xl"
          variant="action"
        >
          <span
            className={cn(
              "text-action! text-size-body",
              disabled && "text-on-disabled",
            )}
          >
            {count}
          </span>
          <Icon
            type="fas"
            name="user"
            size="xs"
            className={cn("text-action-quiet", disabled && "text-on-disabled")}
          />
        </Badge>
      )}

      <Icon
        type="far"
        name="search"
        className={cn(
          "absolute left-2 top-1/2 transform -translate-y-1/2 text-body text-sm leading-2xl",
          showCount && "left-15",
          disabled && "text-on-disabled",
        )}
      />
      <Input
        {...props}
        disabled={disabled}
        className={cn("pl-8.5 text-sm", className, showCount && "pl-20")}
      />
    </div>
  );
};

export default SearchInput;
